<template>
  <div
    v-if="order"
    class="client-phone-section"
    :class="{'client-phone-section__rounded': rounded}"
  >
    <loader
      v-if="loading && rounded"
      absolute
    />

    <template v-if="hasActiveCall">
      <div class="call-processing-label">
        <avatar
          class="operator-avatar"
          :user="operator"
        />
        <div class="operator-info">
          <div class="operator-info_top">
            <i></i>Обрабатывает
          </div>
          <div class="operator-info_bottom">
            {{ operatorName }}
          </div>
        </div>
      </div>
    </template>

    <div v-else class="d-flex align-stretch">
      <component
        :is="canEmitCallback ? 'button' : 'span'"
        class="client-phone d-inline-flex align-center"
        :class="{
          'client-phone__active': isActive,
          'client-phone__rounded': rounded,
          'client-phone__with-info': clientInfoBtnIsVisible,
        }"
        :disabled="loading"
        @click="showCallbackConfirmDialog"
      >
        <font-awesome-icon
          v-if="order.client.phone"
          class="client-phone-icon"
          :class="{nocall: order.basket.noCall }"
          width="19px"
          icon="phone-alt"
        />
        <span class="d-flex flex-column">
          <template v-if="order.client.phone">
            <span class="name">{{ order.client.name }}</span>
            <span class="number font-weight-medium">{{ clientPhone }}</span>
          </template>
          <span
            v-else
            class="name anonim"
          >
            Клиент без регистрации
          </span>
        </span>
      </component>
      <v-btn
        v-if="showInfoBtn && clientPhone"
        class="client-info-btn"
        :class="{'client-info-btn__active': isActive}"
        icon
        large
        @click="$emit('info-btn-click')"
      >
        <font-awesome-icon icon="info" />
      </v-btn>
    </div>
    <primary-confirm-dialog
      v-if="showCallbackConfirm"
      v-model="showCallbackConfirm"
      title="Выполнить звонок клиенту?"
      confirm-text="Позвонить"
      close-after-loading
      :loading="loading"
      @confirm="emitCallback"
    >
      <template #subtitle>
        <h3 class="d-flex j-center ">
          <span class="text--accent-1">{{ clientPhone }}</span>
          <span class="pr-2 pl-2">-</span>
          <span class="font-weight-medium">{{ order.client.name }}</span>
        </h3>
      </template>
    </primary-confirm-dialog>
    <!--  @confirm="toggleStatus"-->
    <!--  @close="closeStatusDialog"-->
  </div>
</template>

<script>
  import snackbarMessage from '@/mixins/snackbar-message'
  import Loader from '@/components/loader/Loader.vue'
  import Avatar from '@/components/administrator/work-shift/staff/Avatar.vue'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import { isArray, round } from 'lodash'
  import OrderStatus from '@/models/enums/OrderStatus'

  export default {
    name: 'ClientPhoneBtn',
    components: { PrimaryConfirmDialog, Avatar, Loader },
    mixins: [snackbarMessage],
    emits: ['info-btn-click'],
    props: {
      order: {
        type: Object,
        default: () => ({}),
      },
      rounded: {
        type: Boolean,
        default: true,
      },
      showInfoBtn: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        loading: false,
        showCallbackConfirm: false,
      }
    },
    computed: {
      isActive () {
        return this.order?.orderStatus === OrderStatus.New
      },
      canEmitCallback () {
        return this.order.client.phone && this.userCan('crm.callback.create')
      },
      hasActiveCall () {
        return !!this.order?.activeCall
      },
      operator () {
        return this.order?.activeCall?.user || {}
      },
      operatorName () {
        return this.operator?.name
      },
      clientPhone () {
        return this.order?.client?.formattedPhone || this.order?.client?.phone
      },
      clientInfoBtnIsVisible () {
        return this.showInfoBtn && this.clientPhone
      },
    },
    methods: {
      isArray,
      round,
      showCallbackConfirmDialog () {
        if (!this.canEmitCallback) {
          return false
        }

        this.showCallbackConfirm = true
      },
      async emitCallback () {
        if (this.order.client.phone) {
          this.loading = true
          try {
            await this.$store.dispatch('orders/emitCallback', { id: this.order.id })
            this.showSuccessMessage('Обратный звонок клиенту инициирован')
          } catch (err) {
            this.showErrorFromResponse(err)
          }
          this.loading = false
        }
      },

    },
  }
</script>

<style scoped lang="less">
.client-phone-section {
  button.client-phone {
    cursor: pointer;
    text-align: left;
  }

  span.client-phone {
    cursor: default;
  }
  .client-phone {
    padding: 9px 21px 7px 16px;
    //margin-right: 24px;
    border-radius: 10px;
    text-decoration: none;
    border: 1px solid #d8d9db;
    color: #000000;
    max-width: 200px;
    .fill-svg(#000000);
    background-color: #f2f3f6;
    min-width: 200px;

    @media (max-width: 1700px) {
      max-width: 165px !important;
      min-width: 165px;
    }

    &:disabled {
      opacity: 0.7;
    }

    &.client-phone__active {
      background-color: @color-primary;
      border: 1px solid @color-primary;
      color: #ffffff;
      .fill-svg(#ffffff);
    }

    &.client-phone____rounded {
      border-radius: 100px;
      background-color: #ffffff;
      border-color: #000000;
    }

    &.client-phone__with-info {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .client-phone-icon {
      font-size: 20px;
      &.nocall {
        path {
          fill: #1EE984 !important;
        }
      }
    }

    .name {
      font-size: 11px;
      line-height: 1.2;
      .media-xl({
        font-size: 14px;
        line-height: 17px;
      });
    }

    .number {
      font-size: 11px;
      line-height: 1.2;
      white-space: nowrap;

      @media (min-width: @md) {
        font-size: 12px;
      }

      .media-xl({
        font-size: 16px;
        line-height: 19px;
      });
    }

    svg {
      width: 17px;
      margin-right: 12px;
    }
  }

  .client-info-btn {
    //border-color: #000 !important;
    font-size: 16px;
    color: #686868;
    background-color: #f2f3f6;
    border: 1px solid  #d8d9db;
    border-radius:  0 10px 10px 0;
    border-left: none;
    width: 45px;
    height: auto !important;

    &.client-info-btn__active {
      background-color: @color-primary;
      border: 1px solid @color-primary;
      border-left: 1px solid #dc7e01;
      color: #ffffff;
    }
    .media-xl({
      font-size: 20px;
      width: 54px;
    })
  }

  .call-processing-label {
    z-index: 300;
    position: relative;
    display: flex;
    align-items: center;

    .operator-avatar {
      margin-right: 7px;
      .media-xl({
        margin-right: 14px;
      })
    }

    .operator-info {
      line-height: 1.25;

      &_top {
        font-size: 11px;
        i {
          display: inline-block;
          background: #1EE984;
          width: 5px;
          height: 5px;
          margin-right: 4px;
          border-radius: 50%;
        }
        .media-xl({
          font-size: 14px;
          i {
            width: 8px;
            height: 8px;
            margin-right: 7px;
          }
        })
      }
      &_bottom {
        //text-align: right;
        font-weight: 500;
        font-size: 13px;
        .media-xl({
          font-size: 16px;
        })
      }
    }
  }

  &__rounded {

  }

}

</style>
